module.exports = __webpack_public_path__ + "img/phone-01.b9de1baa.svg";